var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationMarkBlueIconSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.6646,
    r: 16,
    fill: "#556EE6",
    fillOpacity: 0.25098
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9993 18.3312C17.8377 18.3312 19.3327 16.8362 19.3327 14.9979C19.3327 13.1596 17.8377 11.6646 15.9993 11.6646C14.161 11.6646 12.666 13.1596 12.666 14.9979C12.666 16.8362 14.161 18.3312 15.9993 18.3312ZM15.9994 13.3312C16.9185 13.3312 17.666 14.0787 17.666 14.9979C17.666 15.9171 16.9185 16.6646 15.9994 16.6646C15.0802 16.6646 14.3327 15.9171 14.3327 14.9979C14.3327 14.0787 15.0802 13.3312 15.9994 13.3312Z",
    fill: "#556EE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5174 24.8427C15.6624 24.9461 15.8316 24.9977 16.0007 24.9977C16.1699 24.9977 16.3391 24.9461 16.4841 24.8427C16.7374 24.6636 22.6916 20.3644 22.6674 14.9977C22.6674 11.3219 19.6766 8.33105 16.0007 8.33105C12.3249 8.33105 9.33406 11.3219 9.33406 14.9936C9.30989 20.3644 15.2641 24.6636 15.5174 24.8427ZM16.0007 9.99774C18.7582 9.99774 21.0007 12.2402 21.0007 15.0019C21.0182 18.7002 17.3441 22.0211 16.0007 23.1102C14.6582 22.0202 10.9832 18.6986 11.0007 14.9977C11.0007 12.2402 13.2432 9.99774 16.0007 9.99774Z",
    fill: "#556EE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarkBlueIconSvg);
export default __webpack_public_path__ + "static/media/location-mark-blue-icon-svg.a9f98813.svg";
export { ForwardRef as ReactComponent };